import module from 'facturacion/configuracion/module.js'
import template from './template.html'

export class FacturacionConfiguracionConceptosEditarComponent {
  idConcepto
  onClose
  onChange
  buscarproducto = false
  buscarunidad = false
  data = {
    tipoComprobanteId: undefined,
    clave: '',
    clave_servicio_producto_sat: undefined,
    clave_unidad_medida_sat: undefined,
    factor: undefined,
  }
  actualizando = false
  noencontrado = false
  form = null
  validadoresClave = {
    existe: (value) => (value && this.data.clave !== value)
      ? this.FacturacionConfiguracionConceptosConcepto.get(value, 'existe')
        .then(({data}) => data ? this.$q.reject(`El concepto '${value}' ya existe`) : true)
      : this.$q.when(true)
    ,
  }

  constructor (
    $q,
    $state,
    FacturacionConfiguracionConceptos,
    FacturacionConfiguracionConceptosConcepto,
    FacturacionConfiguracionProductoServicio,
    FacturacionConfiguracionUnidadMedida,
    FacturacionConfiguracionConceptosTipoComprobante,
  ) {
    this.$q = $q
    this.$state = $state
    this.FacturacionConfiguracionConceptos = FacturacionConfiguracionConceptos
    this.FacturacionConfiguracionConceptosConcepto = FacturacionConfiguracionConceptosConcepto
    this.FacturacionConfiguracionProductoServicio = FacturacionConfiguracionProductoServicio
    this.FacturacionConfiguracionUnidadMedida = FacturacionConfiguracionUnidadMedida
    this.FacturacionConfiguracionConceptosTipoComprobante = FacturacionConfiguracionConceptosTipoComprobante
  }

  $onInit () {
    this.$promise = this.$q.all([
      this.idConcepto
        ? this.FacturacionConfiguracionConceptosConcepto.get(this.idConcepto, 'get').then(({data}) => (this.data = data))
        : false,
      this.FacturacionConfiguracionConceptosTipoComprobante.get().then(({data}) => (this.tipoComprobante = data)),
    ])
      .then(() => {
        if (this.data.clave_servicio_producto_sat) this.buscarServicio()
        if (this.data.clave_unidad_medida_sat) this.buscarUnidad()
      })
  }

  cancelar () {
    this.onClose()
  }

  cerrar () {
    this.onClose()
  }

  actualizar (form) {
    if (this.actualizando) return
    this.actualizando = true

    return this.FacturacionConfiguracionConceptosConcepto.put(this.data)
      .then(({data}) => {
        this.data = {...this.data, ...data}
        this.onChange({$event: {details: this.data}})
        form.$setPristine()
      })
      .finally(() => (this.actualizando = false))
  }

  agregar () {
    if (this.actualizando) return
    this.actualizando = true

    return this.FacturacionConfiguracionConceptos.post(this.data)
      .then(({data}) => {
        this.data = {...this.data, ...data}
        this.$state.go('facturacion.configuracion.conceptos.editar', {idConcepto: this.data.id})
      })
      .finally(() => (this.actualizando = false))
  }

  buscarServicio () {
    this.noencontrado = false
    this.data.descripcion_sat = ''

    if (this.data.clave_servicio_producto_sat && this.data.clave_servicio_producto_sat.length === 8) {
      this.FacturacionConfiguracionProductoServicio.get(this.data.clave_servicio_producto_sat)
        .then(({data}) => {
          if (data.descripcion) {
            this.data.descripcion_sat = data.descripcion
          } else {
            this.noencontrado = true
          }
        })
    }
  }

  seleccionarServicio (data) {
    this.buscarproducto = false
    if (!data) return
    this.data.clave_servicio_producto_sat = data.clave
    this.data.descripcion_sat = data.descripcion
    this.noencontradounidad = false
    this.form.$setDirty()
  }

  buscarUnidad () {
    this.noencontradounidad = false
    this.data.descripcion_sat_unidad_medida = ''

    if (this.data.clave_unidad_medida_sat && this.data.clave_unidad_medida_sat.length >= 2) {
      this.FacturacionConfiguracionUnidadMedida.get(this.data.clave_unidad_medida_sat)
        .then(({data}) => {
          if (data.descripcion) {
            this.data.descripcion_sat_unidad_medida = data.descripcion
          } else {
            this.noencontradounidad = true
          }
        })
    }
  }

  seleccionarUnidad (data) {
    this.buscarunidad = false
    if (!data) return
    this.data.clave_unidad_medida_sat = data.clave
    this.data.descripcion_sat_unidad_medida = data.descripcion
    this.noencontradounidad = false
    this.form.$setDirty()
  }

  actualizarImpuestos (impuestos) {
    this.data.impuestos = impuestos
  }

  evaluarTipoComprobante () {
    if (!this.data.tipoComprobanteId) return

    const tipo = this.tipoComprobante.find((item) => item.id === this.data.tipoComprobanteId)
    this.data = {...this.data, ...tipo.predeterminado}
    this.buscarServicio()
    this.buscarUnidad()
  }
}

module.component('facturacionConfiguracionConceptosEditar', {
  controller: FacturacionConfiguracionConceptosEditarComponent,
  template,
  bindings: {
    idConcepto: '<',
    onClose: '&',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/facturacion/configuracion/components/conceptos/editar/component.js